/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.totalLoadedProducts = this.grid.querySelectorAll('.column:not(.promotion-column)').length;
      this.totalProductCount = parseInt(this.dataset.totalProductCount, 10);
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        // Parse the HTML string and find the element with id 'product-grid'
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
        
      // If the product grid is not found in the parsed HTML
      if (!grid_to_replace) {
        // Stop observing if there's an observer
        if (base.observer) {
          base.observer.unobserve(base);
        }
        // Remove the 'loading' attribute
        base.removeAttribute('loading');
        // Hide the button if it exists
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      // Select all products (with class 'column') from the parsed grid
      let products = grid_to_replace.querySelectorAll('.column');
      // Filter out product columns that have the class .promotion-column
      const filteredProducts = Array.from(products).filter(product => !product.classList.contains('promotion-column'));

      this.totalLoadedProducts += filteredProducts.length;

      // Now we need to see if the total number of renderd products is less than the total number of products expected
      // If so, we need to hide the load more button
      if (this.totalLoadedProducts < this.totalProductCount) {
        base.button.classList.remove('visually-hidden');
        base.button.classList.remove('hidden');
      } else {
        base.button.classList.add('visually-hidden');
        base.button.classList.add('hidden');
      }
      // Append each product to the existing grid
      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }
      // If animations are enabled
      if (this.animations_enabled) {
        // Set initial state for animation
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        // Animate products into view
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            // Remove 'loading' attribute when animation completes
            base.removeAttribute('loading');
          }
        });
      } else {
        // If animations are disabled, just remove 'loading' attribute
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}